module.exports = __webpack_public_path__ + "img/headshot-jjackson.e40c6d18.png";